import { Dialog, Tab, RadioGroup, Switch } from "@headlessui/react";
import { useEffect, useRef, useState, useMemo } from "react";
import Button from "../basic/Button";
import starting_out from "../../assets/images/starting_out.jpeg";
import casual_gym from "../../assets/images/casual_gym.jpeg";
import fitness_freak from "../../assets/images/fitness_freak.jpeg";
import curating_playlist from "../../assets/gifs/curating_playlist.gif";
import IconButton from "../basic/IconButton";
import {
  BlackTextLinearGradient,
  BlueLinearGradient,
  BlueTextLinearGradient,
  classNames,
  validateEmail,
  WhiteLinearGradient,
} from "../../utils/Utils";
import { useAuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getEmailExists,
  sendEmailOtp,
  sendMobileOtp,
  updateUserProfile,
  verifyEmailOtp,
  verifyMobileOtp,
} from "../../api/api";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { Icon } from "@iconify/react";
import { getTrackBackground, Range } from "react-range";
import Loader from "../basic/Loader";
import Cookies from "js-cookie";
import CustomDialog from "../basic/Dialog";
import OtpInput from "../basic/OtpInput";

export function OtpVerification({ email, mobile, onVerified }) {
  const [hash, setHash] = useState();
  const [otp, setOtp] = useState();

  async function sendOtp() {
    let response;
    if (email) {
      response = await sendEmailOtp(email);

      if (response.success) {
        toast("OTP Sent");
        setHash(response.hash);
      }
    } else if (mobile) {
      response = await sendMobileOtp("+91" + mobile);

      if (response.status == 200) {
        toast("OTP Sent");
        setHash(response.hash);
      }
    }
  }

  async function verifyOtp() {
    if (otp.length != 4) {
      toast("Otp must be 4 characters");
      return;
    }
    let response;
    if (email) {
      response = await verifyEmailOtp(email, otp.toString(), hash);
      if (response.success) {
        onVerified();
      } else {
        toast("Invalid OTP", { type: "error" });
      }
    } else if (mobile) {
      response = await verifyMobileOtp("+91" + mobile, hash, otp);
      if (response.status == 200) {
        onVerified();
      } else {
        toast("Invalid OTP", { type: "error" });
      }
    }
  }

  useEffect(() => {
    if (!hash) sendOtp();
  }, []);

  return (
    <div className="flex flex-col">
      <p className="text-xl text-center text-white font-bold"> Enter OTP</p>
      <p className="font-bold text-white text-center">
        Please enter the code sent to {email ? email : mobile ? mobile : ""}
      </p>
      <div className="w-full md:max-w-sm self-center flex flex-row justify-center items-center">
        <OtpInput
          onOtpChanged={(otp) => {
            console.log(otp);
            setOtp(otp);
          }}
        />
      </div>

      <Button
        onClick={async () => {
          verifyOtp();
        }}
        type="primary"
        className={"max-w-max mt-6 self-center"}
      >
        Confirm
      </Button>
      <div className="flex flex-row mt-12 items-center max-w-max self-center">
        <p className="font-bold text-customGray-500 mr-5 text-sm">
          Didn't receive OTP?
        </p>
        <div className="flex-1" />
        <div
          className={
            "text-white border-white border-[1px] rounded-full px-4 py-2 text-sm cursor-pointer"
          }
          type="outline"
          onClick={() => {
            sendOtp();
          }}
        >
          Resend
        </div>
      </div>
    </div>
  );
}

export function Step1({
  setLogin,
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  gender,
  setGender,
  height,
  setHeight,
  weight,
  setWeight,
  heightUnit,
  setHeightUnit,
  weightUnit,
  setWeightUnit,
  day,
  setDay,
  month,
  setMonth,
  year,
  setYear,
  workoutGoal,
  setWorkoutGoal,
  workoutDuration,
  setWorkoutDuration,
  register,
  isSocial,
}) {
  const [showOtp, setShowOtp] = useState(false);
  const [passwordInputType, setPasswordInputType] = useState("password");

  return showOtp ? (
    <OtpVerification
      email={email}
      onVerified={() => {
        register();
      }}
    />
  ) : (
    <div
      className={`w-full transform p-6 text-left align-middle transition-all space-y-5`}
    >
      <div as="h2" className="text-2xl font-medium text-left text-gray-900">
        Create your account
      </div>
      <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Name
        </p>
        <input
          className="px-4 py-3  rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
          placeholder="Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
      <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Email
        </p>
        <input
          className="px-4 py-3  rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </div>
      {!isSocial && (
        <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
          <p className="font-medium basis-3/12 text-primary-gray uppercase">
            Password
          </p>
          <div className="px-4 py-3 flex w-full flex-row rounded-lg items-center  border-[1px] bg-transparent border-gray-300 ">
            <input
              className="bg-transparent flex flex-1 placeholder-[#667085] outline-none"
              placeholder="Password"
              value={password}
              type={passwordInputType}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <Icon
              icon={
                passwordInputType === "password"
                  ? "akar-icons:eye"
                  : "akar-icons:eye-slashed"
              }
              color="#667085"
              onClick={() => {
                setPasswordInputType(
                  passwordInputType === "password" ? "text" : "password"
                );
              }}
              className="w-5 h-5 flex self-end"
            />
          </div>
        </div>
      )}
      <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Birthday
        </p>
        <div className="flex flex-row space-x-2 ">
          <input
            className="px-4 py-3 max-w-[80px] md:max-w-[100px] rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder="DD"
            value={day}
            onChange={(e) => {
              setDay(e.target.value);
            }}
            type="number"
            min={1}
            max={31}
          />
          <input
            className="px-4 py-3 max-w-[100px] rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder="MM"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
            }}
            type="number"
            min={1}
            max={12}
          />
          <input
            className="px-4 py-3 max-w-[80px] md:max-w-[100px] rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder="YYYY"
            value={year}
            type="number"
            onChange={(e) => {
              setYear(e.target.value);
            }}
            min={1900}
            max={new Date().getFullYear}
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Sex
        </p>
        <RadioGroup
          value={gender}
          onChange={setGender}
          className="grid grid-cols-2 md:grid-cols-3 gap-4 flex-1"
        >
          <RadioGroup.Option value="male">
            {({ checked }) => (
              <p
                className={`${
                  checked
                    ? `${BlueLinearGradient} text-primary-white `
                    : ` ${BlackTextLinearGradient} border-[1px] border-primary-extraLightBlue`
                } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
              >
                Male
              </p>
            )}
          </RadioGroup.Option>
          <RadioGroup.Option value="female">
            {({ checked }) => (
              <p
                className={`${
                  checked
                    ? `${BlueLinearGradient} text-primary-white `
                    : ` ${BlackTextLinearGradient} border-[1px] border-primary-extraLightBlue`
                } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
              >
                Female
              </p>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </div>
      <p className="font-medium  text-xs text-primary-gray uppercase">
        we are inclusive of all genders, however we need your biological sex for
        scientific purposes
      </p>
      <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Height
        </p>
        <div className="flex flex-row items-center space-x-2">
          <input
            className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder={heightUnit}
            value={height}
            onChange={(e) => {
              setHeight(e.target.value);
            }}
            type="number"
          />
          <p
            className={`${
              heightUnit == "cm" ? BlueTextLinearGradient : "text-primary-gray"
            } font-medium`}
          >
            CENT.
          </p>
          <Switch
            checked={heightUnit == "ft"}
            onChange={(checked) => {
              if (checked) {
                setHeightUnit("ft");
              } else {
                setHeightUnit("cm");
              }
            }}
            className={`${BlueLinearGradient}
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <span
              aria-hidden="true"
              className={`${
                heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
              }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
            >
              <span
                aria-hidden="true"
                className={`${
                  heightUnit == "ft" ? "translate-x-0" : "-translate-x-0"
                }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
              />
            </span>
          </Switch>

          <p
            className={`${
              heightUnit == "ft" ? BlueTextLinearGradient : "text-primary-gray"
            } font-medium`}
          >
            FT.
          </p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          Weight
        </p>
        <div className="flex flex-row items-center space-x-2">
          <input
            className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-[#667085] bg-transparent border-gray-300 "
            placeholder={weightUnit}
            value={weight}
            onChange={(e) => {
              setWeight(e.target.value);
            }}
            type="number"
          />
          <p
            className={`${
              weightUnit == "KG" ? BlueTextLinearGradient : "text-primary-gray"
            } font-medium`}
          >
            KG.
          </p>
          <Switch
            checked={weightUnit == "lbs"}
            onChange={(checked) => {
              if (checked) {
                setWeightUnit("lbs");
              } else {
                setWeightUnit("KG");
              }
            }}
            className={`${BlueLinearGradient}
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <span
              aria-hidden="true"
              className={`${
                weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
              }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
            >
              <span
                aria-hidden="true"
                className={`${
                  weightUnit == "lbs" ? "translate-x-0" : "-translate-x-0"
                }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
              />
            </span>
          </Switch>
          <p
            className={`${
              weightUnit == "lbs" ? BlueTextLinearGradient : "text-primary-gray"
            } font-medium`}
          >
            LBS.
          </p>
        </div>
      </div>
      <p className="font-medium basis-3/12 text-primary-gray uppercase">
        What describes you?
      </p>
      <RadioGroup
        value={workoutGoal}
        onChange={setWorkoutGoal}
        className="grid grid-cols-2 md:grid-cols-4 gap-4 flex flex-1"
      >
        <RadioGroup.Option value={0}>
          {({ checked }) => (
            <div className="cursor-pointer">
              <img
                src={starting_out}
                className={`${
                  checked ? `border-primary-blue ` : `border-transparent`
                } border-2 rounded-2xl w-full h-44 object-cover`}
              />
              <p className="uppercase font-medium text-lg text-center text-primary-gray">
                Starting Out
              </p>
            </div>
          )}
        </RadioGroup.Option>
        <RadioGroup.Option value={1}>
          {({ checked }) => (
            <div className="cursor-pointer">
              <img
                src={casual_gym}
                className={`${
                  checked ? `border-primary-blue ` : `border-transparent`
                } border-2 rounded-2xl w-full h-44 object-cover`}
              />
              <p className="uppercase font-medium text-lg text-center text-primary-gray">
                Casual Gym Goer
              </p>
            </div>
          )}
        </RadioGroup.Option>
        <RadioGroup.Option value={2}>
          {({ checked }) => (
            <div className="cursor-pointer">
              <img
                src={fitness_freak}
                className={`${
                  checked ? `border-primary-blue ` : `border-transparent`
                } border-2 rounded-2xl w-full h-44 object-cover`}
              />
              <p className="uppercase font-medium text-lg text-center text-primary-gray">
                Fitness Freak
              </p>
            </div>
          )}
        </RadioGroup.Option>
      </RadioGroup>
      {workoutGoal !== 0 && (
        <p className="font-medium basis-3/12 text-primary-gray uppercase">
          How often do you workout in a week?
        </p>
      )}
      {workoutGoal !== 0 && (
        <div className="relative ">
          <Range
            aria-label="Workout Duration"
            step={1}
            min={1}
            max={7}
            values={workoutDuration}
            onChange={(values) => {
              setWorkoutDuration(values);
            }}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  background: getTrackBackground({
                    values: workoutDuration,
                    colors: ["#0B28AC", "#6376CD"],
                    min: 1,
                    max: 7,
                  }),
                  cursor: "pointer",
                }}
                className="w-full h-2 mt-12 rounded-full "
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                aria-label="meeting minutes thumb"
                {...props}
                style={{
                  ...props.style,
                  outline: "none",
                  cursor: "pointer",
                }}
                className={`flex justify-center`}
              >
                <div
                  className={`${BlueLinearGradient} rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
                >
                  {workoutDuration[0]}
                </div>
                <span
                  aria-hidden="true"
                  className={`
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                >
                  <span
                    aria-hidden="true"
                    className={`
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                  />
                </span>
              </div>
            )}
          />
        </div>
      )}

      <div className="flex justify-center">
        <Button
          onClick={async () => {
            if (!name) {
              toast("Name is required", { type: "error" });
            } else if (!email) {
              toast("Email is required", { type: "error" });
            } else if (!validateEmail(email)) {
              toast("Invalid email", { type: "error" });
            } else if (!password && !isSocial) {
              toast("Password is required", { type: "error" });
            } else if (!isSocial && password?.length < 8) {
              toast("Password should be at least 8 characters", {
                type: "error",
              });
            } else if (!gender) {
              toast("Gender is required", { type: "error" });
            } else if (!weight || weight < 0) {
              toast("Weight is required", { type: "error" });
            } else if (!height || height < 0) {
              toast("Height is required", { type: "error" });
            } else if (heightUnit != "cm" && (height < 2 || height > 11)) {
              toast("Height must be between 2 and 11 ft.", { type: "error" });
            } else if (weightUnit != "KG" && (weight < 4 || weight > 500)) {
              toast("Weight must be between 4 and 500 lbs.", { type: "error" });
            } else if (
              !day ||
              !month ||
              !year ||
              day > 31 ||
              day < 1 ||
              month < 1 ||
              month > 12 ||
              year > new Date().getFullYear() ||
              year < 1900
            ) {
              toast("Invalid Date of Birth", { type: "error" });
            } else {
              const validEmail = await getEmailExists(email);
              if (validEmail.userFound) {
                toast("User already exists");
              } else {
                if (isSocial) {
                  register();
                } else {
                  setShowOtp(true);
                }
              }
            }
          }}
          type="primary"
          className={"w-2/5 mt-6"}
        >
          Done
        </Button>
      </div>
      {setLogin && (
        <div className="w-full flex flex-col items-center space-y-5">
          <div className="h-[1px] bg-gradient-to-l from-transparent via-primary-gray to-transparent  w-5/6 "></div>
          <div className="flex flex-row justify-center items-center space-x-5">
            <p>Already have an account?</p>
            <Button
              className={`  px-4 py-2 `}
              type="outline"
              onClick={() => setLogin(true)}
            >
              <p className={`${BlueTextLinearGradient}`}>Login</p>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export function CuratingPlaylist({ show, closeDialog }) {
  // useEffect(() => {
  // if (!auth.state.user?.answered || !auth.state.user?.firstLogin) {
  //   return;
  // } else {
  // setShow(true);
  // setTimeout(async () => {
  //   setShow(false);
  //   await updateUserProfile({
  //     update: JSON.stringify({ firstLogin: "0" }),
  //   });
  //   auth.updateUser();
  // }, 6000);
  //     createProgram();
  //   }
  // }, [auth.state.user]);
  return (
    <CustomDialog show={show} close={() => {}}>
      <Dialog.Panel className={`bg-white p-10 rounded-xl`}>
        <div className="flex flex-col h-3/4  items-center justify-center">
          {/* <Loader /> */}
          <img src={curating_playlist} className="h-52 w-52" />
          <p className="text-xl font-medium text-primary-darkPurple">
            Please wait we are curating your recommended program{" "}
          </p>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

function CreateAccountDialog({
  setLogin,
  closeDialog,
  socialLoginDetail,
  initEmail,
  initPassword,
}) {
  const [step, setStep] = useState(0);
  const [name, setName] = useState(socialLoginDetail?.fullname);
  const [email, setEmail] = useState(socialLoginDetail?.email || initEmail);
  const [password, setPassword] = useState(initPassword);
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [gender, setGender] = useState();
  const [workout, setWorkout] = useState(true);
  const [workoutDuration, setWorkoutDuration] = useState([1]);
  const [workoutGoal, setWorkoutGoal] = useState(0);
  const [day, setDay] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const auth = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  async function register() {
    let user = {
      fullname: name,
      email: email,
      height: heightUnit == "ft" ? height * 30.48 : height,
      weight: weightUnit == "lbs" ? weight * 0.453592 : weight,
      workoutDuration: workoutGoal == 0 ? 0 : workoutDuration[0],
      goal: workoutGoal,
      dob: `${day}/${month}/${year}`,
      gender: gender,
    };
    if (socialLoginDetail) {
      user = { ...user, ...socialLoginDetail };
    } else {
      user.password = password;
    }
    const response = await auth.register(user);
    if (response.success) {
      toast("Registration Successful", { type: "success" });
      closeDialog();
      if (location.state?.from?.search) {
        navigate(location.state.from.pathname + location.state.from.search);
      } else {
        navigate("/programpage");
      }
    } else {
      toast(response.msg, { type: "error" });
    }
  }

  return (
    <>
      <div className="flex flex-col items-center space-y-3">
        {step == 0 && (
          <Step1
            setStep={setStep}
            setLogin={setLogin}
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            height={height}
            setHeight={setHeight}
            weight={weight}
            setWeight={setWeight}
            day={day}
            setDay={setDay}
            month={month}
            setMonth={setMonth}
            year={year}
            setYear={setYear}
            heightUnit={heightUnit}
            setHeightUnit={setHeightUnit}
            weightUnit={weightUnit}
            setWeightUnit={setWeightUnit}
            gender={gender}
            setGender={setGender}
            workout={workout}
            setWorkout={setWorkout}
            workoutDuration={workoutDuration}
            setWorkoutDuration={setWorkoutDuration}
            workoutGoal={workoutGoal}
            setWorkoutGoal={setWorkoutGoal}
            register={register}
            isSocial={!!socialLoginDetail}
          />
        )}
        {/* {step == 1 && <Step2 setStep={setStep}
          dateOfBirth={dateOfBirth}
          setDateOfBirth={setDateOfBirth}
          weight={weight} setWeight={setWeight}
          height={height} setHeight={setHeight} />}
        {step == 2 && <Step3 setStep={setStep}
          program={program}
          setProgram={setProgram}
        />}
        {step == 3 && <Step4 register={register}
          setWorkout={setWorkout}
          setAchieve={setAchieve}
          setSport={setSport}
        />} */}
      </div>
    </>
  );
}

export default CreateAccountDialog;
